/**
 * Sub-view tabs — V109-5-2..5-4 (design S2 / R-a): a row of links under the stage heading, ONE
 * `aria-current="page"`, a 3px bar under the current one (only the current one in forced colors,
 * punch #7), horizontally scrollable on phones. Used for the Scope sub-views (Components · Inventory ·
 * Verdicts · Strategies · Plan) and the current stage (Readiness | Changes since the last sweep).
 * Links stay client-side; `onPick` lets a host that keeps its own state (the Scope tab) handle it.
 */
import { Link } from 'react-router-dom';
import './sweep.css';

export interface SubNavItem { key: string; label: string; href: string; count?: string | number | null; countLabel?: string }

export function SubNav({ label, items, current, onPick }: { label: string; items: readonly SubNavItem[]; current: string; onPick?: (key: string) => void }) {
  return (
    <nav aria-label={label}>
      <ul className="sw-subnav">
        {items.map((i) => (
          <li key={i.key}>
            <Link to={i.href} aria-current={i.key === current ? 'page' : undefined}
              onClick={onPick ? (e) => { if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); onPick(i.key); } : undefined}>
              {i.label}
              {i.count !== undefined && i.count !== null && i.count !== '' ? <span className="sw-count">{i.count}{i.countLabel ? <span className="sr-only">{` ${i.countLabel}`}</span> : null}</span> : null}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
